import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';

export const leaveApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLeaveApplies: builder.query({
      query: (params = {}) => ({
        url: '/api/leave_applies',
        params: buildListQueryParams({
          ...params,
          account_id:
            params?.account_id != null && params.account_id !== ''
              ? String(params.account_id)
              : undefined,
        }),
      }),
      providesTags: (_result, _error, params) =>
        params?.account_id != null
          ? ['LeaveApplies', { type: 'LeaveApplies', id: params.account_id }]
          : ['LeaveApplies'],
    }),
    getLeaveApplyById: builder.query({
      query: (id) => `/api/leave_applies?id=${encodeURIComponent(String(id))}`,
      providesTags: (_result, _error, id) => [{ type: 'LeaveApplies', id }],
    }),
    createLeaveApply: builder.mutation({
      query: (payload) => ({
        url: '/api/leave_applies',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['LeaveApplies'],
    }),
    updateLeaveApplyStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/api/leave_applies/${encodeURIComponent(String(id))}`,
        method: 'PUT',
        body: { status },
      }),
      invalidatesTags: (_result, _error, { id }) => ['LeaveApplies', { type: 'LeaveApplies', id }],
    }),
    updateLeaveApply: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/api/leave_applies/${encodeURIComponent(String(id))}/leave_update`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: (_result, _error, { id }) => ['LeaveApplies', { type: 'LeaveApplies', id }],
    }),
    getOutsourceLeaveRequests: builder.query({
      query: (params = {}) => ({
        url: '/api/outsource_leave_requests',
        params: buildListQueryParams({
          account_id:
            params?.account_id != null && params.account_id !== ''
              ? String(params.account_id)
              : undefined,
          page: params?.page,
          per_page: params?.per_page,
        }),
      }),
      providesTags: (_result, _error, params) =>
        params?.account_id != null
          ? ['OutsourceLeaveRequests', { type: 'OutsourceLeaveRequests', id: params.account_id }]
          : ['OutsourceLeaveRequests'],
    }),
    createOutsourceLeaveRequest: builder.mutation({
      query: (outsource_leave_request) => ({
        url: '/api/outsource_leave_requests',
        method: 'POST',
        body: { outsource_leave_request },
      }),
      invalidatesTags: ['OutsourceLeaveRequests'],
    }),
    updateOutsourceLeaveRequest: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `/api/outsource_leave_requests/${encodeURIComponent(String(id))}`,
        method: 'PUT',
        body: { outsource_leave_request: payload },
      }),
      invalidatesTags: ['OutsourceLeaveRequests'],
    }),
    updateOutsourceLeaveStatus: builder.mutation({
      query: ({ id, status, action_by_id, comment }) => ({
        url: `/api/outsource_leave_requests/${encodeURIComponent(String(id))}/update_leave_status`,
        method: 'PUT',
        body: { status, action_by_id, comment },
      }),
      invalidatesTags: ['OutsourceLeaveRequests'],
    }),
  }),
});

export const {
  useGetLeaveAppliesQuery,
  useGetLeaveApplyByIdQuery,
  useCreateLeaveApplyMutation,
  useUpdateLeaveApplyStatusMutation,
  useUpdateLeaveApplyMutation,
  useGetOutsourceLeaveRequestsQuery,
  useCreateOutsourceLeaveRequestMutation,
  useUpdateOutsourceLeaveRequestMutation,
  useUpdateOutsourceLeaveStatusMutation,
} = leaveApi;
